import { Box, Grid } from "@mui/material";
import React from "react";

function AdvancedFilter({
  stationFilterData,
  handleActiveFilterOption,
  activeFilterOption,
  resetFilterHadnler,
  setActiveFilterOption,
  setSelectedLocation,
}) {
  return (
    <Box className="mt-6">
      <Grid container rowSpacing={2}>
        {stationFilterData?.map((item) => (
          <Grid
            item
            xs={6}
            lg={3}
            key={item.id}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              transition: "transform .25s",
              transform: "scale(1)",
              transformOrigin: "left center",
              ":hover": {
                transform: "scale(1.05)",
              },
            }}
            onClick={() => handleActiveFilterOption(item?.slug)}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                className={
                  activeFilterOption.includes(item?.slug)
                    ? "icon-active"
                    : "icon"
                }
                sx={{
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "3px solid var(--primary)",
                  borderRadius: "50%",
                  backgroundColor: activeFilterOption.includes(item?.slug)
                    ? "var(--primary)"
                    : "var(--white)",
                  color: activeFilterOption.includes(item?.slug)
                    ? "var(--white)"
                    : "var(--primary)",
                  transition: "all 0.3s",
                  "& svg": {
                    width: "22px",
                    height: "22px",
                  },
                  // <<< correct selector: target the path by class
                  "& .svg-service-color": {
                    fill: "currentColor",
                    transition: "fill 0.25s",
                  },
                }}
              >
                {item.icon}
              </Box>
              <Box
                sx={{
                  paddingLeft: "10px",
                  fontSize: "13px",
                  width: "100px",
                }}
              >
                {item.name}
              </Box>
            </Box>
          </Grid>
        ))}
        {activeFilterOption?.length > 0 && (
          <Grid
            xs={12}
            key="reset"
            sx={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              transition: "transform .25s",
              transform: "scale(1)",
              transformOrigin: "left center",
            }}
            onClick={() => {
              resetFilterHadnler();
              setActiveFilterOption([]);
              setSelectedLocation([]);
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box
                sx={{
                  paddingRight: "10px",
                  paddingTop: "20px",
                  fontSize: "13px",
                  width: "100px",
                  ":hover": {
                    transform: "scale(1.05)",
                  },
                  color: "var(--primary)",
                }}
              >
                Réinitialiser
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default React.memo(AdvancedFilter);
